// extracted by mini-css-extract-plugin
export default {"btn":"Attachment_btn__eXNqg"};